import { render, staticRenderFns } from "./ArchiveCommentList.vue?vue&type=template&id=ecb0c688&"
import script from "./ArchiveCommentList.vue?vue&type=script&lang=js&"
export * from "./ArchiveCommentList.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveCommentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports